import {
  HStack, Text, Input, Button, IconButton
} from '@chakra-ui/react'
import { FaEdit } from 'react-icons/fa'
import { getHexFromColor } from '../../utils/colors'

interface LegendEditorProps {
  name: string
  color: string
  isEditing: boolean
  onStartEdit: () => void
  onChange: (val: string) => void
  onSave: () => void
}

export function LegendEditor({
  name, color, isEditing, onStartEdit, onChange, onSave
}: LegendEditorProps) {
  return (
    <HStack spacing={2} align="center">
      {isEditing ? (
        <>
          <Input
            value={name}
            onChange={(e) => onChange(e.target.value)}
            size="sm"
            width="150px"
            autoFocus
            color="white"
          />
          <Button size="sm" colorScheme="blue" onClick={onSave}>
            Save
          </Button>
        </>
      ) : (
        <>
          <Text color={getHexFromColor(color)} fontWeight="bold">{name}</Text>
          <IconButton
            aria-label="Edit"
            icon={<FaEdit />}
            size="sm"
            variant="outline"
            onClick={onStartEdit}
            bg="transparent"
            borderColor="gray.500"
            color="gray.500"
            _hover={{ bg: 'transparent', borderColor: 'gray.300', color: 'gray.300' }}
            w="32px"
            h="32px"
            minW="32px"
            minH="32px"
          />
        </>
      )}
    </HStack>
  )
} 